import React from 'react';

import Check from './svgs/Check';
import BoxClosed from './svgs/BoxClosed';
import BoxOpen from './svgs/BoxOpen';
import Truck from './svgs/Truck';
import Bill from './svgs/Bill';

const ProgressIcon = (props) => {
  const { type } = props;

  if (type === 'box-closed') return <BoxClosed />;
  if (type === 'box-open') return <BoxOpen />;
  if (type === 'truck') return <Truck />;
  if (type === 'bill') return <Bill />;

  return <Check />;
};

export default ProgressIcon;
